const PRE_FIRST_SIGNER = 1;

export default {
  PRE_FIRST_SIGNER
};
